import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Skeleton } from '@/components/ui/skeleton';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a1f2e] flex items-center justify-center" data-testid="loading-screen">
        <div className="w-full max-w-md space-y-4 p-8">
          <div className="flex items-center justify-center mb-8">
            <span className="text-2xl font-bold text-white">Casino<span className="text-[#4d7cfe]">IQ</span></span>
          </div>
          <Skeleton className="h-4 w-3/4 mx-auto bg-[#252b3b]" />
          <Skeleton className="h-4 w-1/2 mx-auto bg-[#252b3b]" />
          <Skeleton className="h-8 w-32 mx-auto bg-[#252b3b] rounded-lg" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
